<template>
  <section id="targeted-industries" class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-[#f0f2f5]">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
      <div class="text-center mb-10 sm:mb-12 md:mb-16">
        <h2
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#0b105d] mb-4"
          data-aos="fade-up"
        >
          {{ $t('targetedIndustries.title') }}
        </h2>
        <div
          class="w-16 sm:w-20 md:w-24 h-1 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mx-auto"
          data-aos="fade-up"
          data-aos-delay="100"
        ></div>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        <div
          class="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
          data-aos="fade-up"
        >
          <div
            class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <ShoppingCartIcon class="h-8 w-8 sm:h-10 sm:w-10 text-[#fe6d0d]" />
          </div>
          <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
            {{ $t('targetedIndustries.eCommerce').split(':')[0] }}
          </h3>
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
            {{
                $t('targetedIndustries.eCommerce').includes(':')
                  ? $t('targetedIndustries.eCommerce')
                      .substring($t('targetedIndustries.eCommerce').indexOf(':') + 1)
                      .trim()
                  : $t('targetedIndustries.eCommerce')
              }}
          </p>
        </div>
        <div
          class="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div
            class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <HospitalIcon class="h-8 w-8 sm:h-10 sm:w-10 text-[#fe6d0d]" />
          </div>
          <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
            {{ $t('targetedIndustries.mentalPhysicalHealth').split(':')[0] }}
          </h3>
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
            {{
                $t('targetedIndustries.mentalPhysicalHealth').includes(':')
                  ? $t('targetedIndustries.mentalPhysicalHealth')
                      .substring($t('targetedIndustries.mentalPhysicalHealth').indexOf(':') + 1)
                      .trim()
                  : $t('targetedIndustries.mentalPhysicalHealth')
              }}
          </p>
        </div>
        <div
          class="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div
            class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <TicketIcon class="h-8 w-8 sm:h-10 sm:w-10 text-[#fe6d0d]" />
          </div>
          <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
            {{ $t('targetedIndustries.ticketing').split(':')[0] }}
          </h3>
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
            {{
                $t('targetedIndustries.ticketing').includes(':')
                  ? $t('targetedIndustries.ticketing')
                      .substring($t('targetedIndustries.ticketing').indexOf(':') + 1)
                      .trim()
                  : $t('targetedIndustries.ticketing')
              }}
          </p>
        </div>
        <div
          class="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div
            class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <GraduationCapIcon class="h-8 w-8 sm:h-10 sm:w-10 text-[#fe6d0d]" />
          </div>
          <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
            {{ $t('targetedIndustries.onlineTraining').split(':')[0] }}
          </h3>
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
            {{
                $t('targetedIndustries.onlineTraining').includes(':')
                  ? $t('targetedIndustries.onlineTraining')
                      .substring($t('targetedIndustries.onlineTraining').indexOf(':') + 1)
                      .trim()
                  : $t('targetedIndustries.onlineTraining')
              }}
          </p>
        </div>
         <div
          class="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div
            class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <HousePlusIcon class="h-8 w-8 sm:h-10 sm:w-10 text-[#fe6d0d]" />
          </div>
          <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
            {{ $t('targetedIndustries.interiorDesign').split(':')[0] }}
          </h3>
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
            {{
                $t('targetedIndustries.interiorDesign').includes(':')
                  ? $t('targetedIndustries.interiorDesign')
                      .substring($t('targetedIndustries.interiorDesign').indexOf(':') + 1)
                      .trim()
                  : $t('targetedIndustries.interiorDesign')
              }}
          </p>
        </div>
         <div
          class="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div
            class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#fe6d0d]/10 to-[#ffb47c]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
          >
            <FactoryIcon class="h-8 w-8 sm:h-10 sm:w-10 text-[#fe6d0d]" />
          </div>
          <h3 class="text-lg sm:text-xl font-bold text-[#0b105d] mb-2 sm:mb-3">
            {{ $t('targetedIndustries.industrialEnterprises').split(':')[0] }}
          </h3>
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed flex-grow">
            {{
                $t('targetedIndustries.industrialEnterprises').includes(':')
                  ? $t('targetedIndustries.industrialEnterprises')
                      .substring($t('targetedIndustries.industrialEnterprises').indexOf(':') + 1)
                      .trim()
                  : $t('targetedIndustries.industrialEnterprises')
              }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { FactoryIcon, ShoppingCartIcon, HousePlusIcon, GraduationCapIcon, TicketIcon, HospitalIcon } from 'lucide-vue-next'
</script>
